import React, { Component, Fragment } from "react";
import { debounce } from "lodash";
import api from "services/api";
import { Link } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import swalold from "sweetalert";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CPF from "gerador-validador-cpf";
import CSVReader from "react-csv-reader";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as BenefitsActions,
  Selectors as BenefitsSelectors,
} from "store/ducks/benefits";

import { Access } from "common";
import { Form, Icon, Loading, InfoIcon } from "components";
import { ImportProducts, ImportCPF } from "./components";
import ptBr from "date-fns/locale/pt-BR";
import { startOfDay, endOfDay } from "date-fns";
registerLocale("pt-BR", ptBr);

const MySwal = withReactContent(swal);

class CustomForm extends Component {
  static defaultProps = {
    edit: false,
  };

  state = {
    data: this.props.data,
    loading_cpf_list: false,
    cpf_list_lines: [],
    cpf_list_file: [],
    coupons_limit: true,
    campaigns: [],
    categories: [],
    stores: [],
    channels: [],
    productTypes: [],
    sections: [],
    subSections: [],
    products: [],
    passions: [],
    REACT_APP_MAX_IMPORT_LENGTH: 0,
    collapses: {
      interests: false,
      products: false,
    },
    addStoreProducts: false,
    removeStoreProducts: false,
    groups: [],
    subGroups: [],
  };

  constructor(props) {
    super(props);

    const {
      getBenefitTypesRequest,
      getBenefitChannelsRequest,
      getBenefitCommercialCampaignsRequest,
      getBenefitRegionsRequest,
      getBenefitStoresRequest,
      getBenefitProductTypesRequest,
      getBenefitSectionsRequest,
      getBenefitSubSectionsRequest,
      getBenefitProductsRequest,
      getBenefitPassionsRequest,
    } = props;

    this.handleSearchTypes = debounce(getBenefitTypesRequest, 300);
    this.handleSearchChannel = debounce(getBenefitChannelsRequest, 300);
    this.handleSearchCampaign = debounce(
      getBenefitCommercialCampaignsRequest,
      300
    );
    this.handleSearchRegion = debounce(getBenefitRegionsRequest, 300);
    this.handleSearchStore = debounce(getBenefitStoresRequest, 300);
    this.handleSearchProductType = debounce(getBenefitProductTypesRequest, 300);
    this.handleSearchSection = debounce(getBenefitSectionsRequest, 300);
    this.handleSearchSubSection = debounce(getBenefitSubSectionsRequest, 300);
    this.handleSearchProduct = debounce(getBenefitProductsRequest, 300);
    this.handleSearchPassion = debounce(getBenefitPassionsRequest, 300);
  }

  componentDidMount() {
    const {
      getBenefitCategoriesRequest,
      getBenefitTypesRequest,
      getBenefitChannelsRequest,
      getBenefitCommercialCampaignsRequest,
      getBenefitRegionsRequest,
      getBenefitProductTypesRequest,
      getBenefitSectionsRequest,
      getBenefitProductsRequest,
      getBenefitPassionsRequest,
      getBenefitStoresRequest,
    } = this.props;

    getBenefitCategoriesRequest();
    getBenefitTypesRequest("", true);
    getBenefitChannelsRequest();
    getBenefitCommercialCampaignsRequest("", true);
    getBenefitRegionsRequest();
    getBenefitProductTypesRequest();
    getBenefitSectionsRequest();
    getBenefitProductsRequest();
    getBenefitPassionsRequest();
    getBenefitStoresRequest();
    this.loadMaxImportLength();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { loading, onChange } = this.props;

    const parsedCpfList = this.filterValidCpfs(data.cpf_list);

    if (parsedCpfList.length > 0 && data.promoted === false) {
      this.setState({ data: { ...data, promoted: true } });
    }

    if (oldProps.loading && !loading && oldProps.data !== this.props.data) {
      const {
        store_sub_sections,
        store_groups,
        store_sub_groups,
        store_subgroups,
      } = this.props.data.extra_data;

      const storeSubGroups = store_sub_groups
        ? store_sub_groups
        : store_subgroups;

      const groups = store_sub_sections ? [...store_groups] : [];
      const subGroups = store_groups ? [...storeSubGroups] : [];

      this.setState({
        coupons_limit: this.props.data.activation_limit === 0,
        data: {
          ...this.props.data,
        },
        groups,
        subGroups,
      });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = (e) => {
    const { data } = this.state;
    const { name, value } = e.target;

    const newState = { data: { ...data, [name]: value } };

    if (name === "discount") {
      newState.data.title = `${value}%`;
    }

    this.setState(newState);
  };

  handleChangePeriod = (e) => {
    const { data } = this.state;
    const { value } = e.target;

    this.setState({
      data: { ...data, activation_period: value === "true" ? true : false },
    });
  };

  handleChangeCoupon = (e) => {
    const { value } = e.target;

    this.setState({ coupons_limit: value === "true" ? true : false });
  };

  filterValidCpfs = (cpfs) => cpfs.filter((cpf) => cpf !== null && cpf !== "");

  handleToggle = async (name) => {
    const { data } = this.state;

    const parsedCpfList = this.filterValidCpfs(data.cpf_list);

    if (data.promoted === true && parsedCpfList.length > 0) {
      await MySwal.fire({
        title: "Ação não permitida",
        text: 'Benefícios com CPFs atrelados são exibidos na seção "Cupons em destaque", portanto não é permitido desmarcar esta opção',
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: "Entendi",
      });
      return;
    }

    this.setState(({ data }) => ({
      data: {
        ...data,
        [name]: !data[name],
      },
    }));
  };

  handleToggleExtra = (name) => {
    const { data } = this.state;

    if (name === "add_mdh") {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: !data.extra_data[name],
            remove_mdh: false,
          },
        },
      });
    } else if (name === "remove_mdh") {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: !data.extra_data[name],
            add_mdh: false,
          },
        },
      });
    } else {
      this.setState({
        data: {
          ...data,
          extra_data: { ...data.extra_data, [name]: !data.extra_data[name] },
        },
      });
    }
  };

  handleChangeDate = (name, value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        [name]:
          name === "end_at"
            ? endOfDay(value)
            : name === "start_at"
            ? startOfDay(value)
            : value,
      },
    });
  };

  handleSelectCategory = (option) => {
    const { data } = this.state;

    this.setState({ data: { ...data, voucher_category_id: option } });
  };

  handleFindTypes = (value) => {
    this.handleSearchTypes(value, true);
  };

  handleSelectType = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        experience_voucher_configuration_id: value,
      },
    });
  };

  handleFindChannel = (value) => {
    this.handleSearchChannel(value);
  };

  handleSelectChannels = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        store_channels: value,
        store_channels_all: !value.length,
      },
    });
  };

  handleSelectStores = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_places: value,
          store_places_all: false,
        },
      },
    });
  };

  handleFindCampaign = (value) => {
    this.handleSearchCampaign(value, true);
  };

  handleSelectCampaign = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        experience_commercial_campaigns_id: value,
      },
    });
  };

  handleFindRegion = (value) => {
    this.handleSearchRegion(value);
  };

  handleSelectRegions = (value) => {
    const { data } = this.state;

    if (value !== null) {
      this.handleSearchStore("", value.value);
    }

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_region: value,
          store_places: [],
          store_places_all:
            value !== null ? false : data.extra_data.store_places_all,
        },
      },
    });
  };

  handleFindProductType = (value) => {
    this.handleSearchProductType(value);
  };

  handleSelectProductTypes = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_product_types: value,
          store_product_types_all: false,
        },
      },
    });
  };

  handleFindSection = (value) => {
    this.handleSearchSection(value);
  };

  handleSelectSections = async (value, a, b) => {
    const { data } = this.state;

    if (!value) {
      value = [];
    }

    this.setState(
      {
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            store_sections: value,
            store_sections_all: false,
          },
        },
      },
      () => this.handleFindSubSection("")
    );
  };

  handleFindSubSection = (value) => {
    const { data } = this.state;

    data.extra_data.store_sections.length
      ? this.handleSearchSubSection(
          value,
          data.extra_data.store_sections[0].value
        )
      : this.handleSearchSubSection(value);
  };

  handleSelectSubSections = (value) => {
    const { data } = this.state;

    if (!value) {
      value = [];
    }

    const groups = value
      .map(({ subSection }) => {
        return subSection.attributes.groups;
      })
      .flat()
      .map((group) => {
        return {
          value: group.id,
          label: group.name,
          external_id: group.external_id,
          group,
        };
      });

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_sub_sections: value,
          store_sub_sections_all: false,
          store_groups: data.extra_data.store_groups.filter(
            (group) => !!groups.find((g) => g.group === group.value)
          ),
        },
      },
      groups,
    });
  };

  handleSelectGroups = (value) => {
    const { data } = this.state;

    if (!value) {
      value = [];
    }

    const subGroups = value
      .map(({ group }) => group.sub_groups)
      .flat()
      .map((subGroup) => ({
        value: subGroup.id,
        label: subGroup.name,
        external_id: subGroup.external_id,
      }));

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_groups: value,
          store_sub_groups: data.extra_data.store_sub_groups.filter(
            (subGroup) => !!subGroups.find((sg) => sg.value === subGroup.value)
          ),
        },
      },
      subGroups,
    });
  };

  handleSelectSubGroups = (value) => {
    const { data } = this.state;

    if (!value) {
      value = [];
    }

    this.setState({
      data: {
        ...data,
        extra_data: { ...data.extra_data, store_sub_groups: value },
      },
    });
  };

  handleFindProduct = (value) => {
    this.handleSearchProduct(value);
  };

  handleSelectAddProduct = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: { ...data.extra_data, add_store_products: value },
      },
    });
  };

  handleSelectRemoveProduct = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: { ...data.extra_data, remove_store_products: value },
      },
    });
  };

  handleFindPassion = (value) => {
    this.handleSearchPassion(value);
  };

  handleSelectPassions = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          classification_passions: value,
          classification_passions_all: false,
        },
      },
    });
  };

  loadMaxImportLength = async () => {
    const response = await api.get(
      `settings/v2/confs/search?name=REACT_APP_MAX_IMPORT_LENGTH`
    );
    const { data } = response.data;
    const { value } = data.attributes;

    this.setState({
      REACT_APP_MAX_IMPORT_LENGTH: value,
    });
  };

  handleToggleCollapses = (name, e) => {
    e.preventDefault();
    const { collapses } = this.state;

    this.setState({ collapses: { ...collapses, [name]: !collapses[name] } });
  };

  handleApprove = async () => {
    const { data } = this.state;
    const { approveBenefitRequest, filters } = this.props;

    const approve = await swalold({
      title: "Aprovar Benefício",
      text: "Deseja mesmo aprovar?",
      buttons: {
        cancel: "Cancelar",
        confirm: {
          text: "Sim, aprovar",
        },
      },
    });

    !!approve && approveBenefitRequest(data.id, { filters });
  };

  handleDownload = async () => {
    const { exportReportBenefitsRequest, filters } = this.props;
    const { data } = this.state;

    exportReportBenefitsRequest(
      { id: data.id, title: data.title },
      { filters }
    );
  };
  handleRepprove = async () => {
    const { data } = this.state;
    const { repproveBenefitRequest, filters } = this.props;

    const obs = await swalold({
      title: "Reprovar Benefício",
      text: "",
      content: {
        element: "input",
        attributes: {
          value: "",
          placeholder: "Descreva o motivo",
        },
      },
      buttons: {
        cancel: "Cancelar",

        confirm: {
          text: "Reprovar",
        },
      },
    });

    if (obs === "") {
      await swalold(
        "Você precisa adicionar uma observação para reprovar o benefício",
        "",
        "error"
      );
      this.handleRepprove();
    } else if (obs !== null) {
      repproveBenefitRequest(data.id, { voucher: { obs }, filters });
    }
  };

  handleToggleAddStoreProduct = () => {
    const { addStoreProducts } = this.state;

    this.setState({ addStoreProducts: !addStoreProducts });
  };

  handleToggleRemoveStoreProduct = () => {
    const { removeStoreProducts } = this.state;

    this.setState({ removeStoreProducts: !removeStoreProducts });
  };

  handleImportProducts = async (grid, name) => {
    const { data } = this.state;
    const MAX_IMPORT_LENGTH = this.state.REACT_APP_MAX_IMPORT_LENGTH;
    try {
      this.setState({ importing: true });
      const skus = grid
        .map((sku) => sku[0].value)
        .filter((sku) => sku !== null && sku !== "")
        .join(`&skus[]=`);

      const response = await api.get(
        `store/v2/products?per=${MAX_IMPORT_LENGTH}&skus[]=${skus}`
      );
      const products = response.data.data;

      let newList = [
        ...data.extra_data[name],
        ...products
          .filter(
            (product) =>
              !data.extra_data[name]
                .map((item) => item.value)
                .includes(product.id)
          )
          .map((product) => {
            return {
              sku: product.attributes.sku,
              value: product.id,
              label: product.attributes.sku,
            };
          }),
      ];
      if (newList.length > MAX_IMPORT_LENGTH) {
        newList = newList.slice(0, MAX_IMPORT_LENGTH);

        swalold(
          `Máximo ${MAX_IMPORT_LENGTH} produtos`,
          `O limite máximo de produtos é ${MAX_IMPORT_LENGTH}, todos os produtos que excederam o limite não foram importados.`,
          `info`
        );
      }

      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: newList,
          },
        },
      });
    } catch (error) {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: [],
          },
        },
      });
    } finally {
      this.setState({ importing: false });
    }
  };

  handleLoadCSV = async (listOfCpfs) => {
    listOfCpfs.shift();

    const { data, cpf_list_file } = this.state;
    const { cpf_list } = data;
    this.setState({ loading_cpf_list: true });

    const cpfs = listOfCpfs
      .flat()
      .filter((item) => item !== null && item !== "")
      .map((item) => {
        return CPF.format(item, "digits");
      });

    await new Promise((resolve) => setTimeout(resolve, 1000));

    this.setState(
      {
        data: { ...data, cpf_list: [...cpf_list, ...cpfs] },
        cpf_list_file: [...cpf_list_file, ...cpfs],
      },
      () => {
        this.setState({ loading_cpf_list: false });
      }
    );
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { onSave } = this.props;

    onSave();
  };

  handleChangeCPFs = (value) => {
    const { data } = this.state;
    const { cpf_list } = data;

    this.setState({
      data: {
        ...data,
        cpf_list: [
          ...new Set(
            this.filterValidCpfs([...cpf_list, ...value])
            .map((cpf) => cpf)
          ),
        ],
      },
      cpf_list_lines: value,
    });
  };

  showListOfCpfs = async () => {
    const { data } = this.state;

    await MySwal.fire({
      title: "Lista de CPF's",
      html: (
        <table className="modal-table">
          <tr>
            <th>CPF</th>
          </tr>
          {this.filterValidCpfs(data.cpf_list).map((cpf) => (
            <tr>
              <td>{cpf}</td>
            </tr>
          ))}
        </table>
      ),
      showCloseButton: true,
      showCancelButton: false,
      confirmButtonText: "Ok",
    });
  };

  handleToggleAllProducts = async (name) => {
    const { data } = this.state;

    if (!data.extra_data.all_products) {
      const handleAllProducts = await swalold({
        title: "Cadastrar todos os produtos",
        text: "Deseja cadastrar todos os produtos?",
        buttons: {
          cancel: "Não",

          confirm: {
            text: "Sim",
          },
        },
      });

      if (handleAllProducts) {
        this.setState({
          data: {
            ...data,
            extra_data: {
              ...data.extra_data,
              store_product_types: Access.lockedProductType()
                ? [Access.lockedProductType(true)]
                : [],
              store_product_types_all: Access.lockedProductType()
                ? false
                : false,
              store_sections: [],
              store_sections_all: false,
              store_sub_sections: Access.lockedSection()
                ? [Access.lockedSection(true)]
                : [],
              store_sub_sections_all: Access.lockedSection() ? false : false,
              store_groups: [],
              store_sub_groups: [],
              remove_mdh: false,
              add_mdh: false,
              add_store_products: [],
              remove_store_products: [],
              [name]: !data.extra_data[name],
            },
          },
        });
      }
    } else {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: !data.extra_data[name],
          },
        },
      });
    }
  };

  render() {
    const {
      data,
      coupons_limit,
      REACT_APP_MAX_IMPORT_LENGTH,
      collapses,
      addStoreProducts,
      removeStoreProducts,
      groups,
      subGroups,
      importing,
      cpf_list_lines,
      loading_cpf_list,
    } = this.state;
    const {
      errors,
      saving,
      regions,
      stores,
      types,
      channels,
      commercialCampaigns,
      productTypes,
      sections,
      subSections,
      products,
      passions,
      edit,
      approve,
      repprove,
      filters,
    } = this.props;

    return (
      <Form className="page-form" onSubmit={this.handleSubmit}>
        <h3 className="form-title">Detalhes do Benefício</h3>

        {data.voucher_status === "reproved" && (
          <div className="alert alert-warning">
            <h4>Reprovado</h4>

            {data.voucher_status_obs}
          </div>
        )}

        <Form.Field>
          <Form.Label>Desconto (%)</Form.Label>
          <Form.Input
            type="number"
            min={1}
            max={99}
            name="discount"
            placeholder="Digite o desconto (%)"
            value={data.discount}
            onChange={this.handleChangeInput}
            errors={errors.discount}
            focus={1}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Título</Form.Label>
          <Form.Input
            name="title"
            placeholder="Desconto em produtos para Piscina"
            value={data.title}
            onChange={this.handleChangeInput}
            errors={errors.title}
            // disabled={edit && data.active === true}
          />

          <small className="characters">
            Título contém {data.title.length} caracteres
          </small>
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Tipo de benefício</Form.Label>
          <Form.Select
            placeholder="Tipo de benefício"
            noOptionsMessage={() => "Tipo de Benefício não encontrado"}
            options={types.data}
            onChange={this.handleSelectType}
            onInputChange={this.handleFindTypes}
            value={data.experience_voucher_configuration_id}
          />
        </Form.Field>

        <Form.Field className="checkbox-field margin-top-30">
          <Form.Label>
            Publicar com destaque
            <InfoIcon
              id={data.id}
              info='Ao marcar esta opção, o benefício será exibido na seção "Cupons em destaque"'
            />
          </Form.Label>

          <Form.Checkbox
            checked={data.promoted}
            onChange={() => this.handleToggle("promoted")}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.TextArea
            name="description"
            placeholder="Descontos em produtos para cuidadar da sua piscina."
            value={data.description}
            onChange={this.handleChangeInput}
            errors={errors.description}
            // disabled={edit && data.active === true}
          />
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Campanha Comercial</Form.Label>
          <Form.Select
            placeholder="Campanha comercial"
            noOptionsMessage={() => "Procurar campanha comercial"}
            options={commercialCampaigns.data}
            onInputChange={this.handleFindCampaign}
            onChange={this.handleSelectCampaign}
            value={data.experience_commercial_campaigns_id}
            isClearable
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Pontos</Form.Label>
          <Form.Input
            name="value"
            placeholder="Pontos"
            value={data.value}
            onChange={this.handleChangeInput}
            // disabled={edit && data.active === true}
          />
        </Form.Field>

        <Form.Field className="radio-field">
          <Form.Label>Período</Form.Label>

          {/* <Form.Label className="radio">
            <Form.Input
              type="radio"
              name="activation_period"
              value="false"
              checked={data.activation_period ? false : true}
              className="none-class"
              onChange={this.handleChangePeriod}
            />
            Ilimitado
          </Form.Label> */}

          {/* <Form.Label className="radio">
            <Form.Input
              type="radio"
              name="activation_period"
              value="true"
              checked={data.activation_period ? true : false}
              className="none-class"
              onChange={this.handleChangePeriod}
            />
            Determinado
          </Form.Label> */}
        </Form.Field>

        {data.activation_period && (
          <Fragment>
            <Form.Field className="datepicker-field" errors={errors.start_at}>
              <Form.Label>Início</Form.Label>
              <DatePicker
                locale="pt-BR"
                selected={data.start_at}
                onChange={(value) => this.handleChangeDate("start_at", value)}
                dateFormat="dd/MM/yyyy"
                className={errors.start_at && "parsley-error"}
              />
              <div className="icon-input">
                <span className="glyph glyph-calendar" />
              </div>
            </Form.Field>

            <Form.Field className="datepicker-field" errors={errors.end_at}>
              <Form.Label>Fim</Form.Label>
              <DatePicker
                locale="pt-BR"
                selected={data.end_at}
                onChange={(value) => this.handleChangeDate("end_at", value)}
                dateFormat="dd/MM/yyyy"
                className={errors.end_at && "parsley-error"}
              />
              <div className="icon-input">
                <span className="glyph glyph-calendar" />
              </div>
            </Form.Field>
          </Fragment>
        )}

        <Form.Field className="radio-field">
          <Form.Label>Quantidade de Cupons (emissão de 1 por CPF)</Form.Label>

          <Form.Label className="radio">
            <Form.Input
              name="coupons_limit"
              type="radio"
              value="true"
              className="none-class"
              onChange={this.handleChangeCoupon}
              checked={coupons_limit ? true : false}
            />
            Ilimitado
          </Form.Label>

          <Form.Label className="radio">
            <Form.Input
              name="coupons_limit"
              type="radio"
              value="false"
              className="none-class"
              onChange={this.handleChangeCoupon}
              checked={coupons_limit ? false : true}
            />

            {!coupons_limit ? (
              <Form.Input
                name="activation_limit"
                placeholder="Insira a quantidade desejada"
                onChange={this.handleChangeInput}
                value={data.activation_limit}
              />
            ) : (
              "Definir Quantidade"
            )}
          </Form.Label>
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Canais</Form.Label>
          <Form.Select
            isMulti
            placeholder="Canais"
            noOptionsMessage={() => "Procurar canais"}
            options={channels.data}
            onInputChange={this.handleFindChannel}
            onChange={this.handleSelectChannels}
            value={data.store_channels}
            isDisabled={!!Access.lockedChannel() || data.store_channels_all}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Todos os canais</Form.Label>
          <Form.Checkbox
            checked={data.store_channels_all}
            onChange={() => this.handleToggle("store_channels_all")}
          />
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Região</Form.Label>
          <Form.Select
            placeholder="Região"
            noOptionsMessage={() => "Procurar região"}
            options={regions.data}
            onInputChange={this.handleFindRegion}
            onChange={this.handleSelectRegions}
            value={data.extra_data.store_region}
            isDisabled={!!Access.lockedStore()}
            isClearable
          />
        </Form.Field>

        <h1>{Access.lockedStore()}</h1>

        <Form.Field className="field-select">
          <Form.Label>Lojas</Form.Label>
          <Form.Select
            isMulti
            placeholder="Lojas"
            noOptionsMessage={() => "Procurar lojas"}
            options={stores.data}
            onChange={this.handleSelectStores}
            value={data.extra_data.store_places}
            isDisabled={!!Access.lockedStore()}
          />
        </Form.Field>

        {!Access.lockedStore() && (
          <Form.Field className="checkbox-field">
            <Form.Label>Todos as lojas</Form.Label>
            <Form.Checkbox
              name="store_places_all"
              checked={data.extra_data.store_places_all}
              onChange={() => this.handleToggleExtra("store_places_all")}
              disabled={data.extra_data.store_region !== null}
            />
          </Form.Field>
        )}

        <div className="form-section">
          <h4 className="form-section-title">
            Públicos
            <button
              className="form-section-toggler"
              onClick={(e) => this.handleToggleCollapses("interests", e)}
            >
              <Icon
                name={collapses.interests ? "caret-up" : "caret-down"}
                prefix="fa"
              />
            </button>
          </h4>

          <div
            className={`form-section-collapse ${
              collapses.interests ? "open" : ""
            }`}
          >
            <Form.Field className="field-select">
              <Form.Label>Interesses</Form.Label>
              <Form.Select
                isMulti
                placeholder="Interesses"
                noOptionsMessage={() => "Procurar interesses"}
                options={passions.data}
                onInputChange={this.handleFindPassion}
                onChange={this.handleSelectPassions}
                value={data.extra_data.classification_passions}
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Desconsiderar os Interesses</Form.Label>
              <Form.Checkbox
                checked={data.extra_data.classification_passions_all}
                onChange={() =>
                  this.handleToggleExtra("classification_passions_all")
                }
              />
            </Form.Field>

            {!!data.cpf_list.length && (
              <button
                className="button"
                type="button"
                onClick={() => this.showListOfCpfs()}
              >
                Ver todos os cpfs
              </button>
            )}

            <ImportCPF
              name="imported_cpfs"
              onChange={this.handleChangeCPFs}
              data={cpf_list_lines}
              limit={1000}
            />

            <div className="csv-file-cpf">
              <span>ou</span>

              <CSVReader onFileLoaded={this.handleLoadCSV} />
              <a href="/assets/downloads/lista-de-cpfs.csv">
                Baixar modelo do arquivo de importação.
              </a>

              <small>
                Obs.: Necessário o envio do CPF considerando 11 dígitos:
                Exemplo: 00999999999 ou 009.999.999-99
              </small>
            </div>
          </div>
          {!!loading_cpf_list && <Loading type="btn" text="  Carregando..." />}
        </div>

        <div className="form-section">
          <Form.Field className="checkbox-field margin-top-30">
            <Form.Label>Vale para todos os produtos</Form.Label>
            <Form.Checkbox
              name="all_products"
              checked={data.extra_data.all_products}
              onChange={() => this.handleToggleAllProducts("all_products")}
            />
          </Form.Field>
        </div>

        <div className="form-section">
          <h4 className="form-section-title">
            Seções/Produtos
            <button
              className="form-section-toggler"
              onClick={(e) => this.handleToggleCollapses("products", e)}
            >
              <Icon
                name={collapses.products ? "caret-up" : "caret-down"}
                prefix="fa"
              />
            </button>
          </h4>

          <div
            className={`form-section-collapse ${
              collapses.products ? "open" : ""
            }`}
          >
            <Form.Field className="field-select">
              <Form.Label>Tipos de produtos</Form.Label>
              <Form.Select
                isMulti
                placeholder="Tipos de produtos"
                noOptionsMessage={() => "Procurar tipos de produtos"}
                options={productTypes.data}
                onInputChange={this.handleFindProductType}
                onChange={this.handleSelectProductTypes}
                value={data.extra_data.store_product_types}
                isDisabled={
                  !!Access.lockedProductType() || data.extra_data.all_products
                }
              />
            </Form.Field>

            {!Access.lockedProductType() && (
              <Form.Field className="checkbox-field">
                <Form.Label>Todos os tipos de produto</Form.Label>
                <Form.Checkbox
                  disabled={data.extra_data.all_products}
                  checked={data.extra_data.store_product_types_all}
                  onChange={() =>
                    this.handleToggleExtra("store_product_types_all")
                  }
                />
              </Form.Field>
            )}

            <Form.Field className="field-select">
              <Form.Label>Seções</Form.Label>
              <Form.Select
                isMulti
                placeholder="Seções"
                noOptionsMessage={() => "Procurar seções"}
                options={sections.data}
                onInputChange={this.handleFindSection}
                onChange={this.handleSelectSections}
                value={data.extra_data.store_sections}
                isDisabled={
                  !!Access.lockedSection() || data.extra_data.all_products
                }
              />
            </Form.Field>

            {!Access.lockedSection() && (
              <Form.Field className="checkbox-field">
                <Form.Label>Todas as seções</Form.Label>
                <Form.Checkbox
                  disabled={data.extra_data.all_products}
                  checked={data.extra_data.store_sections_all}
                  onChange={() => this.handleToggleExtra("store_sections_all")}
                />
              </Form.Field>
            )}

            <Form.Field className="field-select">
              <Form.Label>Subseções</Form.Label>
              <Form.Select
                isMulti
                isDisabled={data.extra_data.all_products}
                placeholder="Subseções"
                noOptionsMessage={() => "Procurar subseções"}
                options={subSections.data}
                onInputChange={this.handleFindSubSection}
                onChange={this.handleSelectSubSections}
                value={data.extra_data.store_sub_sections}
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Todas as sub seções</Form.Label>
              <Form.Checkbox
                disabled={data.extra_data.all_products}
                checked={data.extra_data.store_sub_sections_all}
                onChange={() =>
                  this.handleToggleExtra("store_sub_sections_all")
                }
              />
            </Form.Field>

            {!!groups.length && (
              <Form.Field className="field-select">
                <Form.Label>Grupos</Form.Label>
                <Form.Select
                  isMulti
                  isDisabled={data.extra_data.all_products}
                  placeholder="Grupos"
                  noOptionsMessage={() => "Procurar grupos"}
                  options={groups}
                  onChange={this.handleSelectGroups}
                  value={data.extra_data.store_groups}
                />
              </Form.Field>
            )}

            {!!groups.length && !!subGroups.length && (
              <Form.Field className="field-select">
                <Form.Label>Sub Grupos</Form.Label>
                <Form.Select
                  isMulti
                  isDisabled={data.extra_data.all_products}
                  placeholder="Sub Grupos"
                  noOptionsMessage={() => "Procurar sub grupos"}
                  options={subGroups}
                  onChange={this.handleSelectSubGroups}
                  value={data.extra_data.store_sub_groups}
                />
              </Form.Field>
            )}

            <Form.Field className="checkbox-field">
              <Form.Label>Remover produtos MDH</Form.Label>
              <Form.Checkbox
                disabled={data.extra_data.all_products}
                checked={data.extra_data.remove_mdh}
                onChange={() => this.handleToggleExtra("remove_mdh")}
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Somente Produtos MDH</Form.Label>
              <Form.Checkbox
                disabled={data.extra_data.all_products}
                checked={data.extra_data.add_mdh}
                onChange={() => this.handleToggleExtra("add_mdh")}
              />
            </Form.Field>

            <Form.Field className="field-select">
              <Form.Label>Incluir itens na campanha (LMs)</Form.Label>
              <div className="row">
                <div className="col-md-10">
                  <Form.Select
                    isMulti
                    isDisabled={data.extra_data.all_products}
                    placeholder="Incluir itens na campanha (LMs)"
                    noOptionsMessage={() => "Procurar itens"}
                    options={products.data}
                    onInputChange={this.handleFindProduct}
                    onChange={this.handleSelectAddProduct}
                    value={data.extra_data.add_store_products}
                    className="limited-height"
                  />

                  <small className="characters">
                    {data.extra_data?.add_store_products?.length ?? 0}/
                    {REACT_APP_MAX_IMPORT_LENGTH} produtos
                  </small>
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn-import-products"
                    onClick={this.handleToggleAddStoreProduct}
                    disabled={data.extra_data.all_products}
                  >
                    Importar
                  </button>
                </div>
              </div>

              {addStoreProducts && (
                <ImportProducts
                  name="add_store_products"
                  onImport={this.handleImportProducts}
                  loading={importing}
                />
              )}
            </Form.Field>

            <Form.Field className="field-select">
              <Form.Label>Excluir itens na campanha (LMs)</Form.Label>
              <div className="row">
                <div className="col-md-10">
                  <Form.Select
                    isMulti
                    isDisabled={data.extra_data.all_products}
                    placeholder="Excluir itens na campanha (LMs)"
                    noOptionsMessage={() => "Procurar itens"}
                    options={products.data}
                    onInputChange={this.handleFindProduct}
                    onChange={this.handleSelectRemoveProduct}
                    value={data.extra_data.remove_store_products}
                    className="limited-height"
                  />

                  <small className="characters">
                    {data.extra_data?.remove_store_products?.length ?? 0}/
                    {REACT_APP_MAX_IMPORT_LENGTH} produtos
                  </small>
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn-import-products"
                    onClick={this.handleToggleRemoveStoreProduct}
                    disabled={data.extra_data.all_products}
                  >
                    Importar
                  </button>
                </div>
              </div>

              {removeStoreProducts && (
                <ImportProducts
                  name="remove_store_products"
                  onImport={this.handleImportProducts}
                  loading={importing}
                />
              )}
              <br />
              {data.voucher_status === "approve" && (
                <Form.Label>
                  Total de Produtos: {data.products_amount}
                </Form.Label>
              )}
            </Form.Field>
          </div>
        </div>

        <Form.Field className="checkbox-field margin-top-30">
          <Form.Label>Enviar e-mail</Form.Label>
          <Form.Checkbox
            checked={data.extra_data.send_email}
            onChange={() => this.handleToggleExtra("send_email")}
          />
        </Form.Field>

        {Access.hasPermissions("approve-benefits") && (
          <Form.Field className="checkbox-field">
            <Form.Label>Campanha APP</Form.Label>
            <Form.Checkbox
              checked={data.app_only}
              onChange={() => this.handleToggle("app_only")}
            />
          </Form.Field>
        )}

        <div className="buttons">
          <Link
            to={{ pathname: "/benefits/list", filters }}
            className="button-cancel"
          >
            Cancelar
          </Link>

          {edit &&
            Access.hasPermissions("approve-benefits") &&
            data.voucher_status !== "reproved" && (
              <Form.Button
                type="button"
                className="button-cancel"
                onClick={this.handleRepprove}
                disabled={saving}
              >
                {repprove.loading ? (
                  <Loading type="btn" size="small" text="Reprovando..." />
                ) : (
                  "Reprovar"
                )}
              </Form.Button>
            )}

          {edit &&
            Access.hasPermissions("approve-benefits") &&
            data.voucher_status !== "approve" && (
              <Form.Button
                type="button"
                className="button-save margin-right-15"
                onClick={this.handleApprove}
                disabled={saving}
              >
                {approve.loading ? (
                  <Loading type="btn" size="small" text="Aprovando..." />
                ) : (
                  "Aprovar"
                )}
              </Form.Button>
            )}

          {data.voucher_status === "pending" ||
          window.location.href.includes("/benefits/clone") ||
          window.location.href.includes("/benefits/create") ? (
            <Form.Button
              className="button-save margin-right-15"
              onClick={this.handleSubmit}
              disabled={saving || loading_cpf_list}
            >
              {saving ? (
                <Loading type="btn" size="small" text="Salvando..." />
              ) : (
                "Salvar"
              )}
            </Form.Button>
          ) : null}

          {data.voucher_status === "approve" &&
            !window.location.href.includes("/benefits/clone") && (
              <Form.Button
                type="button"
                className="button-cancel"
                onClick={this.handleDownload}
                disabled={saving}
              >
                {approve.loading ? (
                  <Loading type="btn" size="small" text="Aprovando..." />
                ) : (
                  "CSV"
                )}
              </Form.Button>
            )}

          {(data.voucher_status === "approve" ||
            data.voucher_status === "expired" ||
            data.voucher_status === "pending") &&
          !window.location.href.includes("/benefits/clone") ? (
            <Link
              className="button-save"
              to={{
                pathname: `/benefits/clone`,
                state: { cloneData: data },
              }}
            >
              Clonar
            </Link>
          ) : null}

          {loading_cpf_list && (
            <Loading type="btn" size="small" text="Carregando..." />
          )}
        </div>
      </Form>
    );
  }
}

const mapState = (state) => ({
  categories: {
    ...state.benefits.categories,
    data: BenefitsSelectors.categories(state.benefits.categories.data),
  },
  types: {
    ...state.benefits.types,
    data: BenefitsSelectors.types(state.benefits.types.data),
  },
  channels: {
    ...state.benefits.channels,
    data: BenefitsSelectors.activeChannels(state.benefits.channels.data),
  },
  commercialCampaigns: {
    ...state.benefits.commercialCampaigns,
    data: BenefitsSelectors.commercialCampaigns(
      state.benefits.commercialCampaigns.data
    ),
  },
  regions: {
    ...state.benefits.regions,
    data: BenefitsSelectors.regions(state.benefits.regions.data),
  },
  stores: {
    ...state.benefits.stores,
    data: BenefitsSelectors.stores(state.benefits.stores.data),
  },
  productTypes: {
    ...state.benefits.productTypes,
    data: BenefitsSelectors.productTypes(state.benefits.productTypes.data),
  },
  sections: {
    ...state.benefits.sections,
    data: BenefitsSelectors.sections(state.benefits.sections.data),
  },
  subSections: {
    ...state.benefits.subSections,
    data: BenefitsSelectors.subSections(state.benefits.subSections.data),
  },
  products: {
    ...state.benefits.products,
    data: BenefitsSelectors.products(state.benefits.products.data),
  },
  passions: {
    ...state.benefits.passions,
    data: BenefitsSelectors.passions(state.benefits.passions.data),
  },
  approve: state.benefits.approve,
  repprove: state.benefits.repprove,
});

const mapActions = (dispatch) => bindActionCreators(BenefitsActions, dispatch);

export default connect(mapState, mapActions)(CustomForm);
